import type from '../../types'

export function singUpInitial(data) {
  return {
    type: type.INITIAL_BUSINESS_REQUEST,
    payload: data,
  }
}
